import React, { useState } from "react";
import { PlusThin, MinusThin } from "../assets/img";

const faqData = [
  {
    title: "How is the price per share calculated?",
    content: (
      <>
        <p>
          Athlete share prices are the heartbeat of Sportfolio. They reflect the
          market’s consensus at any given time.
        </p>
        <p className="mt-4">
          The intrinsic value or the IPO price is calculated via our proprietary
          algorithm where we use many attributes such as Offensive Rating,
          Defensive Rating, Assist Ratio, Turnover Ratio, Player Impact
          Estimate, etc.
        </p>
        <p className="mt-4">
          The market price is different from an intrinsic value, it is
          determined with respect to the point where the demand and supply of an
          asset coincides. The value keeps fluctuating based on various factors,
          including news, social media, events, trade, demand, supply, etc.
        </p>
      </>
    ),
  },
  {
    title: "What does a share represent?",
    content: (
      <>
        <p>
          Market price on Sportfolio is the expectations for an athlete’s value
          at the current moment based on market sentiment which is controlled by
          the demand & supply just like the stock market.
        </p>
        <p className="mt-4">
          Each share of an athlete represents two things - The investment in an
          athlete and the ownership representation. A direct correlation to the
          ownership of the team the athlete is playing for.
        </p>
      </>
    ),
  },
  {
    title: "What is an ownership representation?",
    content: (
      <>
        <p>
          If you aren’t ultra-rich, you might think that investing in sports
          team will be out of reach - but today, we make your fractional
          ownership possible via Sportfolio. Be mindful that we are still in
          BETA and testing with selected users.
        </p>
        <p className="mt-4">
          The ownership representation is a direct correlation to the ownership
          of the team that the athlete is playing for. For example, LeBron James
          had a higher “Player Importance” than D’Angelo Russell in 22-23 NBA
          season. If you buy more shares of LeBron, your ownership
          representation in Lakers will be much higher.
        </p>
      </>
    ),
  },
  {
    title: "What happens if an athlete retires?",
    content: (
      <>
        <p>
          This is business as usual. Once an athlete retires due to age,
          performance, or injury, we add your position value to the team itself
          and your team ownership could be held as is, or you will have a choice
          to obtain new players based on the current valuation.
        </p>
      </>
    ),
  },
];

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="font-poppins">
      <h2 className="text-xl md:text-3xl lg:text-4xl font-bold my-6 text-center">
        Frequently Asked Questions
      </h2>

      <div className="w-full space-y-4">
        {faqData.map((item, index) => {
          const isOpen = openIndex === index;

          return (
            <div
              key={index}
              className="overflow-hidden rounded-sm bg-white transition-all duration-300 shadow-[0px_0px_12px_0px_#2727271F]"
            >
              <button
                onClick={() => handleToggle(index)}
                className="w-full p-4 text-left"
              >
                <div className="flex items-center justify-between">
                  <p className="text-base smtext-lg md:text-xl font-semibold">
                    {item.title}
                  </p>
                  <span className="text-lg">
                    {isOpen ? <MinusThin /> : <PlusThin />}
                  </span>
                </div>

                <div
                  className={`transition-all duration-300 ease-in-out overflow-hidden text-gray-700 text-sm smtext-base leading-relaxed ${
                    isOpen
                      ? "max-h-[500px] opacity-100 mt-2"
                      : "max-h-0 opacity-0"
                  }`}
                >
                  {item.content}
                </div>
              </button>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default FAQSection;
